<template>
  <section>
    <div class="columns">
      <div class="column is-12">
        <h1 class="section-head">รายงาน Tax Invoice</h1>
        <div class="columns">
          <div class="column is-2">
            
          </div>

          <div class="column is-10 ">
            <b-field label="" class="pull-right">
              <p class="control">
                <b-button class="button is-info" @click="printPdf" icon-left="print" v-if="filteredData.length > 0">Print</b-button>
              </p>
              <b-field >
                  <b-datepicker
                    v-model="dateStart"
                    :date-formatter="clean_date"
                    placeholder="เริ่มต้น.."
                    icon="calendar">
                  </b-datepicker>
              </b-field>

              <b-field>
                  <b-datepicker
                    v-model="dateEnd"
                    :date-formatter="clean_date"
                    placeholder="สิ้นสุด.."
                    icon="calendar">
                  </b-datepicker>
              </b-field>
              <b-autocomplete
                  v-model="company"
                  placeholder="ชื่อบริษัท"
                  :clear-on-select="false"
                  :keep-first="true"
                  :open-on-focus="true"
                  :data="filteredCustomerObj"
                  field="name"
                  :disabled="customerList.length < 1"
                  expanded
                  >
              </b-autocomplete>
              <p class="control">
                <b-button class="button is-primary" @click="searchOrder" icon-right="search">Search</b-button>
              </p>
              
            </b-field>
          </div>
        </div>
        
        <div>
          
          <b-table
            :data="filteredData"
            :hoverable="true"
            :loading="isTableLoading"
            :paginated="isPaginated"
            :per-page="perPage"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :narrowed="true"
            v-if="orders.length > 0 || isTableLoading"

          >
            <template slot-scope="props">
              <b-table-column field="id" label="PO No." width="150">
                <strong>
                  {{ props.row.po_number }}
                </strong>
              </b-table-column>

              <b-table-column field="ship_date" label="Date" width="100">
                <strong>
                  {{ props.row.ship_date ? moment(props.row.ship_date).format("DD/MM/YYYY") : "-"}}
                </strong>
              </b-table-column>

              <b-table-column field="ship_code" label="Tax Invoice No." width="140">
                  {{ props.row.ship_code ? props.row.ship_code : "-"}}
              </b-table-column>

              <b-table-column field="total_price" label="Amount"  width="140">
                  {{ props.row.total_price ? parseFloat((props.row.total_price) * (100 / ((7) + 100))).formatMoney(2) : "0.00"}}
              </b-table-column>

              <b-table-column field="VAT" label="VAT" width="100">
                  {{ props.row.total_price ? parseFloat(props.row.total_price * (7 / (7 + 100))).formatMoney(2) : "0.00"}}
              </b-table-column>

              <b-table-column field="total_price" label="Total" width="150" class="total_price">
                  {{ props.row.total_price ? parseFloat(props.row.total_price).formatMoney(2):0 }}
              </b-table-column>

              <b-table-column field="payment_date" label="Payment Date" width="100">
                <strong>
                  {{ props.row.payment_date ? moment(props.row.payment_date).format("DD/MM/YYYY") : "-"}}
                </strong>
              </b-table-column>

              <b-table-column field="payment_amount" label="Payment Amount" width="140">
                  {{ props.row.payment_code ? parseFloat(props.row.total_price).formatMoney(2):"-" }}
              </b-table-column>

              <b-table-column field="payment_code" label="Receipt No." width="150" class="total_price">
                  {{ props.row.payment_code ? props.row.payment_code : "-"}}
              </b-table-column>

              <b-table-column field="Outstanding" label="Outstanding" width="150" class="total_price">
                  {{ props.row.payment_code ? "-" : parseFloat(props.row.total_price).formatMoney(2)}}
              </b-table-column>

              <b-table-column field="totalpayment_code_price3" label="Status" width="150" class="total_price">
                  {{ props.row.ship_code ? (props.row.payment_code ? "Shipped, Paid":"Shipped"):"-" }}
              </b-table-column>

              <b-table-column field="remark" label="Remark" width="150" class="total_price">
                  {{ props.row.remark ? props.row.remark:"-"}}
              </b-table-column>

              
            </template>
          </b-table>
          <div class="notification has-text-centered" v-else>ไม่พบข้อมูล</div>
        </div>
      </div>
      
    </div>

  </section>
</template>

<script>
  import CustomerModel from '@/model/customer_model';
  import OrderModel from '@/model/order_model'
  import Const from '@/const/const'
  import moment from 'moment';
  import Config from "@/libraries/config";
  /*
  $sub_total = round(($company_total) * (100 / ((7) + 100)), 2);
  $vat = round($company_total * (7 / (7 + 100)), 2);
  **/
  export default {
  

    data() {
      return {
        orders: [],
        isTableLoading: false,
        selectedItem: null,
        isPaginated: true,
        isPaginationSimple: false,
        currentPage: 1,
        perPage: 20,
        search_query: "",
        moment: moment,
        customerList: [],
        company: "",
        dateStart: new Date(),
        dateEnd: new Date(),
      }
    },
    mounted() {
      this.init();
    },
    computed: {
      filteredData: function() {
        return this.orders.filter(order => {
          return (
                  (order.code && order.code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (order.ship_code && order.ship_code.toLowerCase().includes(this.search_query.toLowerCase()))
                  || (order.company && order.company.toLowerCase().includes(this.search_query.toLowerCase()))
                )
        })
      },
      filteredCustomerObj() {
          return this.customerList.filter((option) => {
            if(option.name.toString().toLowerCase().indexOf(this.company.toLowerCase()) >= 0){
              return option;
            }else{
              return false;
            }
          });
      },
    },
    methods:{
      async init(){
        this.customerList  = await CustomerModel.get_all_customer();
      },
      async searchOrder(){
        let cus_id = 0;
        if(this.company != ""){
          cus_id = this.getCustomerData()[0].id;
        }
        //console.log(cus_id[0].id);
        this.isTableLoading = true;
        this.orders = await OrderModel.get_order_by_customer(cus_id, moment(this.dateStart).format("YYYY-MM-DD 00:00:00"), moment(this.dateEnd).format("YYYY-MM-DD 23:59:59"),"ship");
        this.isTableLoading = false;
      },
      getCustomerData(){
        return this.customerList.filter((option) => {
          if(option.name.toString().toLowerCase().indexOf(this.company.toLowerCase()) >= 0){
            return option;
          }else{
            return false;
          }
        });
      },
      clean_date(date){
        return moment(date).format("YYYY-MM-DD");
      },
      printPdf(){
        window.open(Config.baseUrl +"/v"+Config.version+ "/printpdf/tax_invoice?startDate="+moment(this.dateStart).format("YYYY-MM-DD")+"&endDate="+moment(this.dateEnd).format("YYYY-MM-DD") + (this.company != "" ? "&cus_id=" + this.getCustomerData()[0].id:"" ), '_blank');
      }
    }

  }
</script>

<style scoped>
  .table-style {
    font-size: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Report/tax_invoice.vue